import React from 'react'

import { Outlet, useNavigate } from 'react-router-dom'
export default function MyPhoto() {
  const navigate = useNavigate()
  return (
    <div>
      我的相册页面
      <div>
        <button
          onClick={() => {
            navigate('/photo/add')
          }}
        >
          相册 添加
        </button>
        <button
          onClick={() => {
            navigate('/photo/alter')
          }}
        >
          相册 修改
        </button>
        <button
          onClick={() => {
            navigate('/photo/delete')
          }}
        >
          相册 删除
        </button>
      </div>
      <div>
        <Outlet></Outlet>
      </div>
    </div>
  )
}
